import { _debounce } from "@medicusunion/front-utils";
import { FC, useLayoutEffect, useMemo, useRef } from "react";
import { selectRoomPinned } from "@/store/features/room/selectors";
import { toggleUIPinnedSizes } from "@/store/features/ui/slice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { StyledPinnedPlaceholder } from "./styled";

const debounce = _debounce(100);

const PinnedPlaceholder: FC = () => {
  const dispatch = useAppDispatch();

  const pinned = useAppSelector(selectRoomPinned);

  const ref = useRef<HTMLDivElement | null>(null);

  const hasPinned = useMemo(() => !!pinned, [pinned]);

  useLayoutEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      debounce(() => {
        dispatch(toggleUIPinnedSizes({ width, height }));
      });
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
      dispatch(toggleUIPinnedSizes(null));
    };
  }, [hasPinned, dispatch]);

  if (!hasPinned) {
    return null;
  }

  return (
    <StyledPinnedPlaceholder ref={ref} />
  );
};

export default PinnedPlaceholder;
